import {event} from '@/api'
import {
	AGENDA_EVENT_GET,
	ATTENDEES_EVENT_GET,
	EVENT_GET,
	EVENT_GET_ERROR,
	EVENT_LOADING_STATUS,
	EVENTS_FETCH,
	EVENTS_FETCH_ERROR,
	PARTNERS_EVENT_GET,

	EVENTS_FETCH_CATEGORIES,
	EVENTS_FETCH_CATEGORIES_ERROR,
	REMOVE_ATTENDEES_EVENT,
	ATTENDEE_EVENT_GET,
	SESSION_EVENT_GET,
	SESSION_EVENT_CLEAR,
	SESSION_EVENT_QUESTIONS_GET,
	SESSION_EVENT_QUESTION_UPDATE,
	SESSION_EVENT_QUESTIONS_CLEAR,
	EVENTS_CLEAR,
	EVENT_LOADING_CATEGORIES_STATUS,

	GET_ACTION_FILES,
	GET_ACTION_LINKS
} from '@/store/event/types'

const fetchEvents = async (ctx, filters) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.fetchEvents(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(EVENTS_FETCH, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const fetchEventCategories = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_CATEGORIES_STATUS, true)
	try {
		const { data, headers } = await event.fetchEventCategories(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		}

		ctx.commit(EVENTS_FETCH_CATEGORIES, response)
		ctx.commit(EVENT_LOADING_CATEGORIES_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_CATEGORIES_ERROR, e)
		console.error(e)
	}
}

const getEvent = async (ctx, eventId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)

	try {
		const query = {
			expand: 'is_attendees_available,is_agenda_available,speakersList,partner_groups,eventActions'
		}

		const { data } = await event.getEvent(eventId, query)

		ctx.commit(EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)

		if (data.is_agenda_available){
			ctx.dispatch('getAgendaEvent', `&event_id=${eventId}`)
		}
		if (data.is_attendees_available){
			ctx.dispatch('getAttendeesEvent', `&event_id=${eventId}&filter=event`)
		}
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const getAgendaEvent = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {

		const { data, headers } = await event.getAgendaEvent(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(AGENDA_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getAttendeesEvent = async (ctx, query = '') => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {

		const { data, headers } = await event.getAttendeesEvent(query)
		const pageCount = headers['x-pagination-page-count']
		const totalCount = headers['x-pagination-total-count']
		const response = { data, pageCount, totalCount }

		ctx.commit(ATTENDEES_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getAttendee = async (ctx, id) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.getAttendeeEvent(id)

		ctx.commit(ATTENDEE_EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getSession = async (ctx, id) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.getEventSession(id)

		ctx.commit(SESSION_EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const clearSession = async (ctx) => {
	try {
		ctx.commit(SESSION_EVENT_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getActionFiles = async (ctx, {id, queryString = ''}) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getActionFiles(id, queryString)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		}

		ctx.commit(GET_ACTION_FILES, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getActionLinks = async (ctx, {id, queryString = ''}) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getActionLinks(id, queryString)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		}

		ctx.commit(GET_ACTION_LINKS, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const fetchPartners = async (ctx, filters) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.fetchPartners(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(PARTNERS_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const clearAttendeesEvent = (ctx) => {
	ctx.commit(REMOVE_ATTENDEES_EVENT)
}

const addSessionQuestion = async (ctx, payload) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		await event.addSessionAgendaQuestion(payload)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const getSessionQuestions = async (ctx, payload) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		if (payload.page) {
			ctx.commit(SESSION_EVENT_QUESTIONS_CLEAR)
		}
		if (!payload.session) {
			const { data } = await event.getEventSession(payload.sessionId)
			ctx.commit(SESSION_EVENT_GET, data)
		}
		const { data, headers } = await event.getSessionQuestions({sessionId: payload.sessionId, page: payload.page || 1})
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
		ctx.commit(SESSION_EVENT_QUESTIONS_GET, response)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const upvoteSessionQuestion = async (ctx, answerId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.upvoteSessionQuestion(answerId)
		ctx.commit(SESSION_EVENT_QUESTION_UPDATE, {answerId: data.session_question_answer_id, status: 1})
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const deleteUpvoteSessionQuestion = async (ctx, answerId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.deleteUpvoteSessionQuestion(answerId)
		ctx.commit(SESSION_EVENT_QUESTION_UPDATE, { answerId: data.session_question_answer_id, status: 0 })
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const clearEventCategories = async (ctx) => {
	try {
		ctx.commit(EVENTS_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

export default {
	getEvent,
	getAgendaEvent,
	fetchEvents,
	fetchPartners,
	getAttendeesEvent,
	fetchEventCategories,
	clearAttendeesEvent,
	getAttendee,
	getSession,
	clearSession,
	getActionFiles,
	getActionLinks,
	addSessionQuestion,
	getSessionQuestions,
	upvoteSessionQuestion,
	deleteUpvoteSessionQuestion,
	clearEventCategories
}


